/**
 *  @class
 *  @function Predictive Search
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.currentRequest = null;
      this.lastSearchTerm = '';
    }
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');

      this.setupEventListeners();

    }
    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.predictiveSearchResults.addEventListener('focusout', this.close.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.cc.addEventListener('click', this.close.bind(this));

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
      this.input.addEventListener('focus', this.open.bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        document.body.classList.remove('open-search');
        this.predictiveSearchResults.setAttribute('inert', '');
        return;
      }
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        return;
      }

      // Only fetch if we haven't already searched for this term
      if (searchTerm !== this.lastSearchTerm) {
        this.getSearchResults(searchTerm);
      }
    }

    getSearchResults(searchTerm) {
      // Prevent duplicate requests for the same search term
      if (searchTerm === this.lastSearchTerm && this.currentRequest) {
        return;
      }

      // Cancel any ongoing request
      if (this.currentRequest) {
        this.currentRequest.abort();
      }

      this.lastSearchTerm = searchTerm;
      this.predictiveSearchResults.classList.add('loading');

      // Create AbortController for this request
      const controller = new AbortController();
      this.currentRequest = controller;

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,collection&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[options][fields]')}=title,product_type,variants.title,variants.sku,vendor,tag&section_id=predictive-search`, {
        signal: controller.signal
      })
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            // Request was cancelled, this is expected
            return;
          }
          throw error;
        })
        .finally(() => {
          // Clear the current request reference
          if (this.currentRequest === controller) {
            this.currentRequest = null;
          }
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      let submitButton = this.querySelector('#search-results-submit');

      submitButton.addEventListener('click', () => {
        this.form.submit();
      });
    }

    close() {
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search');
      // Cancel any ongoing request when closing
      if (this.currentRequest) {
        this.currentRequest.abort();
        this.currentRequest = null;
      }
      // Reset last search term so fresh search can be made when reopened
      this.lastSearchTerm = '';
    }
    open() {
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
    }
  }
  customElements.define('search-form', SearchForm);
}




document.addEventListener("mouseup", function (e) {
  var clickplace = document.querySelector(".thb-predictive-search, .header-search--input-container #header-search-input");

  if (clickplace && !clickplace.contains(e.target)) {
    var searchInput = document.querySelector(".header-search--input-container #header-search-input");
     if (false) { // Zusss: zoekterm niet meer wissen bij klikken buiten het zoekveld
      // Only clear if there's a value and delay to prevent interference with form submission
      setTimeout(function() {
        if (document.body.classList.contains('open-search')) {
          searchInput.value = '';
          searchChange();
        }
      }, 300);
    }
  }
});

function searchChange() {
  var url = window.location.href;
  fetch(url)
    .then(response => response.text())
    .then(html => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      if (doc.querySelector('.thb-predictive-search') != null) {
       var mainSectionContent = doc.querySelector('.thb-predictive-search').innerHTML;
       document.querySelector('.thb-predictive-search').innerHTML = mainSectionContent;
      }
    })
    .catch(error => {
      console.error('Error fetching collection main section:', error);
    });
}












/* Zusss: Enter in de zoekbalk gaat direct naar de resultatenpagina */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;
  var input = e.target.closest && e.target.closest('search-form input[type="search"]');
  if (!input) return;
  var q = input.value.trim();
  if (!q) return;
  var W = window.Weglot;
  if (W && W.getCurrentLang && W.options && W.getCurrentLang() !== W.options.language_from) return;
  e.preventDefault();
  var form = input.closest('form');
  window.location.href = (form ? form.getAttribute('action') : '/search') + '?q=' + encodeURIComponent(q);
});